<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row dense class="no-gutters pb-5">
        <v-col cols="12" sm="12" md="6" lg="3" :md="$canRoute('withdraw-partner-tab') !== 1 ? 12 : 6" :lg="$canRoute('withdraw-partner-tab') !== 1 ? 5 : 3">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search..." single-line solo
            hide-details></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="3">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                readonly v-bind="attrs" v-on="on" solo class="custom-select"></v-text-field>
            </template>
            <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
                Cancel
              </v-btn>
              <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" sm="8" md="6" lg="3">
          <ul>
            <li>
              <span>Withdraw Amount:</span>
              <span>{{ withdrawals?.totalApprovedWithdraw || 0 }}</span>
            </li>
            <li>
              <span>Pending Trx</span>
              <span>{{ withdrawals?.totalPendingWithdraw || 0 }}</span>
            </li>
          </ul>
        </v-col>

        <v-col cols="12" sm="4" md="6" lg="2" class="text-right" v-if="$canRoute('withdraw-partner-tab') === 1">
          <v-dialog transition="scale-transition" origin="center center" max-width="450" v-model="dialog"
            content-class="commission-tree">
            <template v-slot:activator="{ on, attrs }">
              <v-btn tile elevation="0" small class="mt-8 text-capitalize btn-account mb-0 mx-1" color="greenMain"
                v-bind="attrs" v-on="on">
                Withdraw
              </v-btn>
            </template>
            <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
              <v-card-title class="pb-3 text-left justify-start pl-3">
                Withdraw
              </v-card-title>
              <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash d-flex align-center justify-space-between">
                Withdraw Money From Here
              </v-card-subtitle>
              <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                ">
                <v-row>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Trx. Method</legend>
                      <v-select solo v-model="data.selectedPaymentMethod" :items="slots3" append-icon="mdi-chevron-down"
                        label="Click to Select" class="custom-select" hide-details></v-select>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Amount</legend>
                      <v-text-field single-line label="USD" v-model="data.amount" solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" v-if="data.selectedPaymentMethod == 'Internal Transfer'">
                    <fieldset>
                      <legend>To Account</legend>
                      <v-text-field single-line label="Trading account no" v-model="data.tradding_acc" solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Remarks</legend>
                      <v-text-field single-line label="Enter Remarks/Comment" v-model="data.remarks" solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Upload a Slip or Screenshot <span class="optional">(Optional)</span></legend>
                      <v-file-input ref="fileInput" v-model="data.bankSlip" label="Upload a Slip or Screenshot"
                        :accept="'.jpg,.jpeg,.png,.pdf'" solo hide-details class="custom-select" prepend-icon=""
                        @change="handleFileUpload">
                        <template v-slot:selection="{ text }">
                          <span>{{ text || 'Upload file' }}</span>
                        </template>
                      </v-file-input>
                    </fieldset>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions>
                <v-row dense>
                  <v-col cols="12">
                    <v-btn tile @click="ibwithdraw" elevation="0" :loading="loading" :disabled="loading"
                      class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">Confirm</v-btn>
                    <v-btn tile color="#FF567F" @click="closeModal" elevation="0"
                      class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <transaction-tab-data-table :withdrawals="withdrawals?.allWithdrawalRequests || []"
          :search="search"></transaction-tab-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import TransactionTabDataTable from './TransactionTabDataTable.vue';
import { mapState, mapActions } from "vuex";
import { PARTNERLIST__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      search: "",
      slots1: [{ text: "A" }, { text: "B" }, { text: "C" }],
      slots2: [{ text: "A" }, { text: "B" }, { text: "C" }],
      slots3: [{ text: "Cash Withdraw" }, { text: "Internal Transfer" }],
      date: ["2022-01-01", "2023-01-01"],
      modal: false,
      dialog: false,
      selectedDates: [],
      selectedDatesText: null,
      loading: false,

      data: {
        id: '',
        amount: '',
        tradding_acc: '',
        remarks: '',
        bankSlip: null,
        selectedPaymentMethod: null,
      }
    };
  },
  components: { TransactionTabDataTable },
  computed: {
    ...mapState("partnerlist", ["withdrawals"]),
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
  methods: {
    ...mapActions("partnerlist", [PARTNERLIST__ACTIONS.WITHDRAWALS, PARTNERLIST__ACTIONS.IBWITHDRAWAL, PARTNERLIST__ACTIONS.PARTNERSUMMARY]),
    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    handleFileUpload(file) {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/webp', 'application/pdf'];
      const maxSize = 4 * 1024 * 1024; // 4MB+


      if (!file) return;

      if (!allowedTypes.includes(file.type)) {
        toast.error('Invalid file type. Please upload PNG, JPEG, WEBP, or PDF');
        this.data.bankSlip = null;
        this.$refs.fileInput.value = '';
        return;
      }

      if (file.size > maxSize) {
        toast.error('File size must be less than 4MB');
        this.data.bankSlip = null;
        this.$refs.fileInput.value = '';
        return;
      }
    },

    async ibwithdraw() {
      this.loading = true;
      try {
        this.data.id = this.$route.query.id;

        const formData = new FormData();
        formData.append('amount', this.data.amount);
        formData.append('tradingAccount', this.data.tradding_acc);
        formData.append('remarks', this.data.remarks);
        formData.append('paymentType', this.data.selectedPaymentMethod);
        formData.append('client_account_id', this.data.id);
        formData.append('payment_slip', this.data.bankSlip);

        await this[PARTNERLIST__ACTIONS.IBWITHDRAWAL](formData);
        await this[PARTNERLIST__ACTIONS.WITHDRAWALS]({ partner_id: this.$route.query.id });
        await this[PARTNERLIST__ACTIONS.PARTNERSUMMARY]({ partner_id: this.$route.query.id });
      } catch (error) {
        console.error("IB Withdrawal Error:", error);
      } finally {
        this.loading = false;
        this.dialog = false;
        this.data.amount = '';
        this.data.tradding_acc = '';
        this.data.remarks = '';
        this.data.selectedPaymentMethod = '';
        this.data.bankSlip = null;
      }
    },


    closeModal() {
      this.data.amount = '';
      this.data.tradding_acc = '';
      this.data.remarks = '';
      this.data.selectedPaymentMethod = '';
      this.data.bankSlip = null;
      this.dialog = false;
      this.loading = false;
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        console.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        partner_id: this.$route.query.id,
        duration: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`
      };

      this[PARTNERLIST__ACTIONS.WITHDRAWALS](parameter);

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },
  },
  async mounted() {
    await this[PARTNERLIST__ACTIONS.WITHDRAWALS]({ partner_id: this.$route.query.id });
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>